import React from "react";
import { createRoot } from "react-dom/client";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import App from "./App";
import { platformService } from "./services/platform";
import { liveUpdateService } from "./services/liveUpdate";
import { report } from "@services/Sentry.ts";

liveUpdateService.initialize();

// Initialize PWA Elements for Camera plugin browser support
defineCustomElements(window);

// Register service worker for PWA/web (not for native apps)
if (!platformService.isNative() && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("SW registered:", registration.scope);
      })
      .catch((error) => {
        console.error("SW registration failed:", error);
        report(error);
      });
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
